exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__logtext___3Ct6G {\r\n  color: #00FF00;\r\n  background-color: black;\r\n  font-family: \"Hack\";\r\n  padding-left: 20px;\r\n}\r\n\r\n.style__dialogRoot___2i-Yq {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n  -ms-flex-pack: distribute;\r\n      justify-content: space-around;\r\n}\r\n\r\n.style__scroll___39oiS {\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n  height: 60vh;\r\n  white-space: pre-wrap;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1;\r\n          flex: 1;\r\n}\r\n", "", {"version":3,"sources":["/./components/LogDialog/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;CACpB;;AAED;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;EACd,oBAAgB;MAAhB,gBAAgB;EAChB,0BAA8B;MAA9B,8BAA8B;CAC/B;;AAED;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oBAAQ;MAAR,YAAQ;UAAR,QAAQ;CACT","file":"style.css","sourcesContent":[".logtext {\r\n  color: #00FF00;\r\n  background-color: black;\r\n  font-family: \"Hack\";\r\n  padding-left: 20px;\r\n}\r\n\r\n.dialogRoot {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-around;\r\n}\r\n\r\n.scroll {\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n  height: 60vh;\r\n  white-space: pre-wrap;\r\n  flex: 1;\r\n}\r\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"logtext": "style__logtext___3Ct6G",
	"dialogRoot": "style__dialogRoot___2i-Yq",
	"scroll": "style__scroll___39oiS"
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../~/postcss-loader!./components/LogDialog/style.css
 ** module id = 1034
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../~/postcss-loader!./components/LogDialog/style.css
 ** module id = 1034
 ** module chunks = 1
 **/